import React, { Component } from 'react';
import styles from './GenericIcon.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';
const rootClassName = styles.rootClassName;

class EditIcon extends Component {
  render() {
    const style = {
      ...(this.props.style || {}),
    };
    return (
      <svg
        className={getMergedClassNames([
          rootClassName,
          this.props.className || '',
        ])}
        viewBox='0 0 24 24'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
      >
        <path
          d='M20.4531 6.04688L18.6562 7.84375C18.5521 7.94792 18.4349 8 18.3047 8C18.1745 8 18.0703 7.94792 17.9922 7.84375L13.6562 3.50781C13.5521 3.42969 13.5 3.32552 13.5 3.19531C13.5 3.0651 13.5521 2.94792 13.6562 2.84375L15.4531 1.04688C15.8177 0.682292 16.2604 0.5 16.7812 0.5C17.3021 0.5 17.7448 0.682292 18.1094 1.04688L20.4531 3.39062C20.8177 3.75521 21 4.19792 21 4.71875C21 5.23958 20.8177 5.68229 20.4531 6.04688ZM12.0938 4.40625L1.85938 14.6406L1 19.4062C0.947917 19.7188 1.03906 19.9922 1.27344 20.2266C1.50781 20.4609 1.78125 20.5521 2.09375 20.5L6.85938 19.6406L17.0938 9.40625C17.1979 9.30208 17.25 9.1849 17.25 9.05469C17.25 8.92448 17.1979 8.82031 17.0938 8.74219L12.7578 4.40625C12.6797 4.30208 12.5755 4.25 12.4453 4.25C12.3151 4.25 12.1979 4.30208 12.0938 4.40625ZM5.84375 13.7812C5.73958 13.6771 5.6875 13.5469 5.6875 13.3906C5.6875 13.2344 5.73958 13.1042 5.84375 13L11.8594 6.98438C11.9635 6.88021 12.0938 6.82812 12.25 6.82812C12.4062 6.82812 12.5365 6.88021 12.6406 6.98438C12.7448 7.08854 12.7969 7.21875 12.7969 7.375C12.7969 7.53125 12.7448 7.66146 12.6406 7.76562L6.625 13.7812C6.52083 13.8854 6.39062 13.9375 6.23438 13.9375C6.07812 13.9375 5.94792 13.8854 5.84375 13.7812ZM4.4375 17.0625H6.3125V18.4688L3.8125 18.9375L2.5625 17.6875L3.03125 15.1875H4.4375V17.0625Z'
          fill='currentColor'
        />
      </svg>
    );
  }
}

export default EditIcon;
